// extracted by mini-css-extract-plugin
export var assigneeBadge = "_j0-0";
export var assigneeDetails = "_j0-1";
export var assigneeInfo = "_j0-2";
export var dropdownContainer = "_j0-4";
export var dropdownImage = "_j0-5";
export var editAssigneeInfo = "_j0-3";
export var editAssigneeModalContainer = "_j0-6";
export var hidden = "_j0-8";
export var input = "_j0-7";